var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThemeParks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Amusement-Park-Rollercoaster--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Amusement Park Rollercoaster Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 18.25c-0.52 0 -1.42 -1.63 -2.07 -2.82C19.27 12.4 17 8.25 12 8.25s-7.27 4.15 -8.93 7.18c-0.65 1.19 -1.55 2.82 -2.07 2.82a1 1 0 0 0 0 2c1.63 0 2.66 -1.72 3.56 -3.38a0.25 0.25 0 0 1 0.28 -0.12A0.24 0.24 0 0 1 5 17v2.26a1 1 0 0 0 2 0v-6.2a0.47 0.47 0 0 1 0.12 -0.32 8.26 8.26 0 0 1 1.48 -1.4 0.25 0.25 0 0 1 0.26 0 0.24 0.24 0 0 1 0.14 0.22v7.71a1 1 0 0 0 2 0v-8.7a0.24 0.24 0 0 1 0.22 -0.25 6.11 6.11 0 0 1 1.56 0 0.24 0.24 0 0 1 0.22 0.25v8.7a1 1 0 0 0 2 0v-7.73a0.24 0.24 0 0 1 0.14 -0.22 0.25 0.25 0 0 1 0.26 0 8.26 8.26 0 0 1 1.45 1.39 0.47 0.47 0 0 1 0.12 0.32v6.2a1 1 0 0 0 2 0V17a0.25 0.25 0 0 1 0.19 -0.25 0.25 0.25 0 0 1 0.28 0.13c0.87 1.61 1.94 3.37 3.56 3.37a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.31 6.75h4.5a0.5 0.5 0 0 0 0.5 -0.5 2.5 2.5 0 0 0 -2.5 -2.5h-2.5a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64 8.37a1 1 0 0 0 0.58 0.5 1.12 1.12 0 0 0 0.31 0.05A1 1 0 0 0 6 8.8l3.1 -1.6a1 1 0 0 0 0.49 -0.58 1 1 0 0 0 -0.06 -0.77L9.07 5a1 1 0 0 0 -1.35 -0.42L4.61 6.14a1 1 0 0 0 -0.49 0.58 1 1 0 0 0 0.06 0.77Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.48 13.4 0.85 0.52a1 1 0 0 0 0.51 0.14 1 1 0 0 0 0.86 -0.48l1.82 -3a0.94 0.94 0 0 0 0.11 -0.75 1 1 0 0 0 -0.45 -0.62l-0.84 -0.51A1 1 0 0 0 2 9L0.15 12a1 1 0 0 0 -0.12 0.76 1 1 0 0 0 0.45 0.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThemeParks);
export default ForwardRef;